
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.9 39.1c-7.6 0-16.5-5.8-20.7-13.6l-.3-.5.3-.5c4.2-7.8 13.2-13.6 20.7-13.6s16.4 5.8 20.7 13.6l.1.2v.5l-.1.2c-4.3 7.8-13.2 13.7-20.7 13.7zM6.2 25c4 6.9 12 12.1 18.7 12.1 6.7 0 14.6-5.2 18.7-12.1-4.1-6.9-12-12.1-18.7-12.1-6.8 0-14.7 5.2-18.7 12.1z"}}),_c('path',{attrs:{"d":"M24.9 32.5c-4.1 0-7.5-3.3-7.5-7.5s3.3-7.5 7.5-7.5c4.1 0 7.5 3.3 7.5 7.5s-3.4 7.5-7.5 7.5zm0-13c-3 0-5.5 2.4-5.5 5.5s2.4 5.5 5.5 5.5c3 0 5.5-2.4 5.5-5.5s-2.5-5.5-5.5-5.5z"}})])
          )
        }
      }
    